<template>
    <Background
        :backPath="'/home'">

        <a-input-search
            v-model="searchContent"
            size="large"
            placeholder="搜索货柜或主控"
            class="search"
            @search="onSearch"
        />

        <div class="search-hint-area">
            <div
                v-if="searching"
                class="search-hint">
                <div class="search-content">
                    搜索到{{ searchNumber }}条
                </div>
                <div
                    v-on:click="cleanSearch"
                    class="clean-search">
                    清空搜索 <a-icon type="close" />
                </div>
            </div>
        </div>

        <ListView
            v-if="searching"
            ref="searchList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :clickCallback="clickCupboard"
            :addCallback="addCupboard"
            :listWidth="90"
        />
        <ListView
            v-else
            ref="userList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :fetchCallback="fetchCupboardList"
            :clickCallback="clickCupboard"
            :addCallback="addCupboard"
            :listWidth="90"
        />

        <div
            v-if="amount > 0"
            class="merchant-amount">
            货柜总数: {{ amount }}
        </div>

        <DownloadQRCodeDialog ref="dialog"/>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import InputSearch from "ant-design-vue/lib/input/Search";
 import DownloadQRCodeDialog from "./DownloadQRCodeDialog.vue"

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import { parseDate } from "../util/date.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'CupboardManage',
     data() {
         return {
             amount: 0,
             searchContent: "",
             searchNumber: 0,
             searching: false,
             titles: ["序号", "主控ID", "货柜编号", "主控编号", "主控哈希", "主控状态", "老板", "商户简称", "识别优先级", "手机号"],
             columnWidths: [5, 5, 5, 20, 5, 10, 20, 10, 10, 10],
             columnCells: [
                 { value: "",
                   style: ""
                 },
                 { value: "Id",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "MachineSerialNum",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "BoxSerialNum",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "BoxHasPassword",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "BoxStatus",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "BossName",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "ShopName",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "Priority",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "BossPhone",
                   style: "text-align: end; padding-right: 20px;"
                 },
             ]
         }
     },
     components: {
         Background,
         ListView,
         DownloadQRCodeDialog
     },
     computed: {
     },
     mounted() {
         this.fetchAmount()
     },
     methods: {
         fetchAmount() {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-box/total`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response.Total) {
                     this.amount = response.Total
                 } else {
                     console.log("fetchAmount error: ", response)
                 }
             })
         },
         clickCupboard(item) {
             sessionStorage.setItem("clickCupboardInfo", JSON.stringify(item))

             this.$router.push("/cupboardInfo")
         },
         fetchCupboardList(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-box?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log("****** ", response)

                 callback(this.handleResponse(response))
             })
         },
         onSearch() {
             this.searching = !isEmptyOrWhitespace(this.searchContent)

             if (this.searching) {
                 this.doSearch()
             }
         },
         doSearch() {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-box/search?q=${this.searchContent}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response) {
                     this.searchNumber = response.length
                     this.$refs.searchList.initList(this.handleResponse(response))
                 } else {
                     this.searchNumber = 0
                     this.$refs.searchList.initList([])
                 }
             })
         },
         cleanSearch() {
             this.searching = false
             this.searchContent = ""
             this.searchNumber = 0

             var that = this
             setTimeout(function () {
                 that.$refs.userList.research()
             }, 100)
         },
         handleResponse(response) {
             for (var i=0; i < response.length; i++) {
                 if (response[i].BoxPasswordHash != "") {
                     response[i].BoxHasPassword = "有"
                 } else {
                     response[i].BoxHasPassword = "无"
                 }

                 if (response[i].Status == 0) {
                     response[i].BoxStatus = "未绑定"
                 } else if (response[i].Status == 2) {
                     response[i].BoxStatus = "已绑定"
                 } else if (response[i].Status == 4) {
                     response[i].BoxStatus = "货柜已激活"
                 } else {
                     response[i].BoxStatus = "状态未知: " + response[i].Status
                 }

                 if (response[i].BossInfo !== null) {
                     response[i].BossPhone = response[i].BossInfo.Phone
                     response[i].BossName = response[i].BossInfo.Username
                 } else {
                     response[i].BossPhone = ""
                     response[i].BossName = ""
                 }

                 if (response[i].ShopInfo !== null) {
                     response[i].ShopName = response[i].ShopInfo.Username
                 } else {
                     response[i].ShopName = ""
                 }

                 if (response[i].MachineInfo !== null) {
                     response[i].Priority = response[i].MachineInfo.Priority
                 } else {
                     response[i].Priority = ""
                 }

                 response[i].CreatedAt = parseDate(response[i].CreatedAt)
                 response[i].UpdatedAt = parseDate(response[i].UpdatedAt)
             }

             return response
         },
         addCupboard() {
             this.$refs.dialog.show()
         }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #999;
 }
</style>
